import { VehicleFuelType } from "@1games-ru/region-shared/dist/enums/vehicle/vehicle";
import { imgGasStationBmw, imgGasStationBmwM2 } from "@/shared/assets/img";
import { GasStationBrand } from "@/domains/gasStation/constants/gasStationBrand";
import { GasStationState } from "@/domains/gasStation/slice";

export const fakeStation: GasStationState["station"] = {
  address: { streetName: "ул. Фрунзенская, 98", index: 0 },
  id: 1,
  name: "АЗС №24",
  fuelTypes: {
    Gas: {
      Standard: {
        id: 0,
        price: 0,
      },
      Good: {
        id: 0,
        price: 0,
      },
      Excellent: {
        id: 0,
        price: 0,
      },
    },
    Diesel: {
      id: 0,
      price: 0,
    },
    Electric: {
      Standard: {
        id: 0,
        price: 0,
      },
      Fast: {
        id: 0,
        price: 0,
      },
    },
    GasAvia: {
      id: 0,
      price: 0,
    },
  },
  brand: GasStationBrand.LUKOIL,
};

export const fakeCar: GasStationState["vehicle"] = {
  id: 123,
  brand: "BMW",
  model: "M2 Competition",
  fuelType: VehicleFuelType.Electric,
  fuelAmount: 45,
  fuelMaxAmount: 60,
  brandImage: imgGasStationBmw,
  modelImage: imgGasStationBmwM2,
};
